import React from 'react';
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input';
import Fade from 'react-reveal/Fade';
import Swal from 'sweetalert2';
import '../styles/global.scss';

const Form = ({ style }) => {
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [isDisabled, setDisabled] = React.useState(true);
  const [isInvalid, setInvalid] = React.useState({
    bool: false,
    content: '',
  });

  const emailCheck = e => {
    setEmail(e);
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (!pattern.test(e)) {
      setInvalid({ bool: true, content: 'is-danger' });
      setDisabled(true);
    } else {
      setInvalid({ bool: false, content: '' });
      enableIt();
    }
  };

  const enableIt = () => {
    if (!isInvalid.bool) setDisabled(false);
  };
  const onFireAlert = () => {
    setDisabled(true);
    Swal.fire({
      icon: 'success',
      title: `Thanks! We'll contact you soon.`,
      showConfirmButton: false,
      timer: 1500,
    });
  };
  return (
    <div style={style}>
      <form
        method='post'
        action='https://formsubmit.co/a1756621ef1b003d471d05687a018818'
        onSubmit={onFireAlert}
        enctype='multipart/form-data'
      >
        <div className='columns'>
          <div className='column is-full'>
            <div className='field '>
              <label className='label'>Name</label>
              <div className='control'>
                <input
                  className='input'
                  style={{ background: '#F9F9F9', boxShadow: 'none' }}
                  type='text'
                  placeholder='Your Name'
                  name='name'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='columns'>
          <div className='column'>
            <div className='field '>
              <label className='label'>Phone Number</label>
              <div className='control'>
                <PhoneInput
                  class='input phone-input-background'
                  countrySelectProps={{ unicodeFlags: true }}
                  placeholder='Enter phone number'
                  style={{ background: '#F9F9F9', boxShadow: 'none' }}
                  value={phone}
                  name='phone'
                  onChange={setPhone}
                  defaultCountry='IN'
                  error={
                    phone
                      ? isPossiblePhoneNumber(phone)
                        ? undefined
                        : 'Invalid phone number'
                      : 'Phone number required'
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className='columns'>
          <div className='column'>
            <div className='field '>
              <label class='label'>Email</label>
              <div class='control'>
                <input
                  class={`input ${isInvalid.content}`}
                  type='email'
                  style={{ background: '#F9F9F9', boxShadow: 'none' }}
                  name='email'
                  placeholder='name@company.com'
                  value={email}
                  onChange={e => emailCheck(e.target.value)}
                />
                <Fade bottom collapse when={isInvalid.bool}>
                  <p className='help is-danger'>This email is invalid</p>
                </Fade>
              </div>
            </div>
          </div>
        </div>
        <input type='hidden' name='_next' value='https://gonuclei.com' />
        <input type="hidden" name="_captcha" value="false"></input>
        <input
          type='hidden'
          name='_subject'
          value='New Website Contact Us form Submission!'
        />
        <input
          type='hidden'
          name='_cc'
          value='sales@gonuclei.com,tanpreet.sehgal@gonuclei.com,siddharth.goyal@gonuclei.com,raghavendra.prasad@gonuclei.com'
        />

        <input
          type='hidden'
          name='_autoresponse'
          value="Thanks for showing interest, We'll contact you in less than 24 hours!"
        />

        <div className='field'>
          <label className='label'>Message</label>
          <div className='control'>
            <textarea
              className='textArea input'
              style={{ background: '#F9F9F9', boxShadow: 'none' }}
              name='message'
              placeholder='I want to know more about Nuclei...'
            ></textarea>
          </div>
        </div>
        <input type='hidden' name='_template' value='table' />

        {/* <input type='hidden' name='_recaptcha' id='_recaptcha' /> */}
        <button type='submit' className='button' disabled={isDisabled}>
          <span className='button-text'>Submit</span>
        </button>
      </form>
    </div>
  );
};

export default Form;
